import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-CaGLN3Vi.mjs"));
export {
  FilePickerVue
};
